export default __webpack_public_path__ + "images/97e1f8afc06cdf0eabb8efbcb5cfa2c5.svg";